import { render } from "./AttendExam.vue?vue&type=template&id=e08c466c&scoped=true"
import script from "./AttendExam.vue?vue&type=script&lang=js"
export * from "./AttendExam.vue?vue&type=script&lang=js"

import "./AttendExam.vue?vue&type=style&index=0&id=e08c466c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e08c466c"]])

export default __exports__